import React from 'react';
import { useQuery } from '@tanstack/react-query';

// components
import { withStyles } from '@mui/styles';
import { CowbellFactorsCharts } from '../../console/customers/dashboard/CowbellFactorsCharts';

// api
import { getRisk } from './InsightsService';

import { useGetCustomerRiskFactors } from '../../components/hooks/useGetCustomerRiskFactors';
import { useAiFactorScores } from '../../components/hooks/useAiCowbellFactors';
import { AiCowbellFactorsPanel } from '../../components/cowbellFactors/AiCowbellFactorsPanel';
import { toUniversalUtcDate } from '../../utils/date.utils';

const CFCharts = ({ classes, accountId }: any) => {
  const { data: riskDate } = useQuery(
    ['account-risk', accountId],
    () =>
      getRisk({ accountId }).then(({ data }: any) => ({
        ui_dateText:
          data.timestamp && `As of: ${toUniversalUtcDate(data.timestamp)}`,
      })),
    {
      enabled: Boolean(accountId),
      placeholderData: { ui_dateText: '' },
    }
  );

  const { cowbellFactorsRiskData, query: customerRiskQuery } =
    useGetCustomerRiskFactors({
      accountId,
    });
  const aiFactorScores = useAiFactorScores(accountId);

  return (
    <section className={classes.container}>
      <CowbellFactorsCharts
        data={cowbellFactorsRiskData}
        isLoading={customerRiskQuery.isInitialLoading}
        riskDate={riskDate}
      />
      <AiCowbellFactorsPanel
        data={aiFactorScores.data}
        isLoading={aiFactorScores.isLoading}
      />
    </section>
  );
};

const styles = ({ palette }: any) => ({
  container: {
    width: '100%',
    backgroundColor: palette.background.lighter,
    // This tile set no radius at all, so it squared off against every rounded
    // tile above and below it.
    borderRadius: 'var(--tile-radius)',
    boxShadow: 'var(--tile-shadow)',
    padding: '1.083rem',
    marginBottom: 'var(--tile-gutter)',
    position: 'relative',
  },
});

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { containe... Remove this comment to see the full error message
export default withStyles(styles, { withTheme: true })(CFCharts);
